// src/routes/routes.js
import React from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import ApplicationForm from '../pages/ApplicationForm';
import ThankyouPage from '../pages/ThankyouPage';
import { FormProvider } from '../contexts/formContexts';

const Routes = () => {
  return (
    <RouterRoutes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/ApplicationForm"
        element={
          <FormProvider>
            <ApplicationForm />
          </FormProvider>
        }
      />
      <Route
        path="/ApplicationForm/:id?"
        element={
          <FormProvider>
            <ApplicationForm />
          </FormProvider>
        }
      />
      <Route path="/thank-you" element={<ThankyouPage />} />
    </RouterRoutes>
  );
};

export default Routes;